import React from 'react'
import { Badge, type BadgeColor } from '@enamelai/design-system'
import { useTheme } from '@context/ThemeContext'

type IntegrationCardProps = {
  name: string
  icon: string
  statusLabel: string
  statusColor: BadgeColor
  children?: React.ReactNode
}

const IntegrationCard = ({
  name,
  icon,
  statusLabel,
  statusColor,
  children,
}: IntegrationCardProps): React.ReactElement => {
  const { resolvedTheme } = useTheme()

  return (
    <div className="integration-card">
      <img src={icon} alt="" className="integration-card-icon" />
      <div className="integration-card-content">
        <span className="integration-card-title">{name}</span>
        <Badge
          mode={resolvedTheme === 'dark' ? 'solid' : 'tinted'}
          color={statusColor}
          label={statusLabel}
        />
      </div>
      {children ? (
        <div className="integration-card-actions">{children}</div>
      ) : null}
    </div>
  )
}

export default IntegrationCard
